import { render, staticRenderFns } from "./DashboardSettings.vue?vue&type=template&id=11aa79fb&"
import script from "./DashboardSettings.vue?vue&type=script&lang=ts&"
export * from "./DashboardSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports